import { VacancyProps } from "storyblok/components";

export function filterVacanciesByDepartment(
    currentVacancy: VacancyProps,
    allVacancies: Array<VacancyProps>
) {
    const requiredDepartment = currentVacancy.department;

    return allVacancies.filter(
        vacancy => vacancy.department === requiredDepartment
    );
}

export function filterVacanciesByKey({
    allVacancies,
    keys
}: {
    keys: Record<string, string | undefined>;
    allVacancies: Array<VacancyProps>;
}) {
    // if no keys are set, skip looping over al vacancies and return all vacancies
    if (Object.values(keys).every(value => !value)) {
        return allVacancies;
    }

    const keyEntries = Object.entries(keys);

    return allVacancies.filter(vacancy => {
        return keyEntries.every(([key, value]) => {
            if (!value) {
                return true;
            }

            return vacancy[key as keyof VacancyProps] === value;
        });
    });
}
